<template>
	<div class="scored">
		<vs-row>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="m-4 p-d">
				        <el-date-picker
							  style="width:100%"
				              v-model="yearmonth"
							  format="yyyy-MM-dd"
							  value-format="yyyy-MM-dd"
				              type="monthrange"
				              range-separator="至"
				              start-placeholder="开始月份"
				              end-placeholder="结束月份">
				        </el-date-picker>
						
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
				<el-input v-model="name" placeholder="请输入姓名" class="ml-4"></el-input>
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
				<vs-button color="primary" type="filled" style="width:100%"  @click="search">搜索</vs-button>
			</vs-col>
			<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
				<vs-button color="primary" type="filled" style="width:100%" @click="reset">重置</vs-button>
			</vs-col>
		</vs-row>
		<vs-table ref="table"    :max-items="10"  :data="culturelist">
		  <template slot="thead">
		    <vs-th >ID</vs-th>
		    <vs-th >名称</vs-th>
			<vs-th >姓名</vs-th>
		    <vs-th >部门</vs-th>
		    <vs-th >手机号</vs-th>
			<vs-th >创建时间</vs-th>
			<vs-th >提交时间</vs-th>
			<vs-th >自评分</vs-th>
			<vs-th >我的评分</vs-th>
			<vs-th >状态</vs-th>
			<vs-th >操作</vs-th>
		  </template>
		    <template slot-scope="{data}">
		      <tbody>
		        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
		          <vs-td>
		            <p class="product-name font-medium">{{ tr.id }}</p>
		          </vs-td>
		          <vs-td>
		            <p class="product-category">{{ tr.name }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.userName }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-category">{{ tr.deptName }}</p>
				  </vs-td>
		          <vs-td>
		            <p class="product-price">{{ tr.phone }}</p>
		          </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.assessTime }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.updateTime?tr.updateTime:'------' }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.totalScore }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price">{{ tr.myTotalScore }}</p>
				  </vs-td>
				  <vs-td>
				    <p class="product-price" :class="tr.status==1?'text-danger':tr.status==2?'text-primary':'text-success'" >{{ tr.status==1?"待填写":tr.status==2?"待考核":"已评分" }}</p>
				  </vs-td>
				  <vs-td>
				    <vs-button class="mr-4" color="primary" type="filled" @click="details(tr)" v-if="tr.status!=10"  size="small">测评</vs-button>
					<vs-button class="mr-4" color="primary" type="filled" @click="todetails(tr)" v-if="tr.status==10"  size="small">详情</vs-button>
					<vs-button class="mr-4" color="primary" type="filled" @click="submit(tr)" v-if="tr.status!=10"  size="small">提交</vs-button>
					<vs-button class="mr-4" color="success" type="filled" @click="exportexcel(tr.id)"  size="small">导出Excel</vs-button>
					<vs-button color="danger" type="filled" @click="back(tr.id)"  v-if="tr.status==10" size="small">退回</vs-button>
				  </vs-td>
		        </vs-tr>
		      </tbody>
		    </template>
		</vs-table>
		<vs-pagination class="mt-4" :total="total" v-model="itemsPerPage" ></vs-pagination>
		<!-- 预览弹窗 -->
		<el-dialog
		  :close-on-click-modal="false"
		  title="预览"
		  :visible.sync="DialogVisible"
		  width="30%"
		  center>
		  <div style="height:50vh;overflow: auto;">
		  <el-descriptions :title="item.dimension" :column="1" v-for="item in preview" :key='item.id'>
		      <el-descriptions-item label="评分项">{{item.behaviors}}</el-descriptions-item>
		      <el-descriptions-item label="我的评语">{{item.remarks}}</el-descriptions-item>
		      <el-descriptions-item label="我的评分">
		        <el-tag size="small">{{item.leaderScore}}</el-tag>
		      </el-descriptions-item>
		  </el-descriptions>
		  </div>
		  <el-form>
		  <el-form-item label="总评语">
		      <el-input type="textarea" v-model="remarks"></el-input>
		  </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitsecend()">提交</el-button>
		  </span>
		</el-dialog>
	</div>
</template>
<script>
	export default {
	    data() {
	        return {
				yearmonth:[], //时间段
				name:"",
				culturelist: [],
				total:0,
				itemsPerPage:1,
				id:'',
				remarks:'',
				DialogVisible:false,
				preview:[],
			}
	    },
		mounted() {
			this.getlist();
		},
		watch: {
		    itemsPerPage:'getlist'
		}, 
		methods:{
			reset(){
				this.yearmonth=[];
				this.name='';
				this.itemsPerPage=1;
				this.getlist();
			},
			search(){
				this.itemsPerPage=1;
				this.getlist();
			},
			back(id){
				console.log("退回id",id);
				var that=this;
				this.$confirm('此操作将退回该记录，须重新进行考核测评, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
							that.$api.backstafflist({id:id}).then(function (response) {
								if(response.code==0){
									 that.$vs.notify({
									 	  title:"提示",
									 	  color:'success',
									 	  text:response.message,
									 	  position:'top-center'
									 });
									 that.getlist();
								}else{
									that.$vs.notify({
										  title:"提示",
										  color:'warning',
										  text:response.message,
										  position:'top-center'
									});
								}
							  }) 
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消'
				          });          
				        });
			},
			submit(item){
				if(item.myTotalScore==0){
					thisIns.$vs.notify({
						  title:"提示",
						  color:'warning',
						  text:"系统检测评分异常，请确认是否已测评",
						  position:'top-center'
					});
					return false;
				}
				this.DialogVisible=true;
				const thisIns = this;
				thisIns.remarks='';
				thisIns.id=item.id;
				this.$api.scorepreview({id:item.id}).then(function (response) {
					console.log("数据预览：",response);
					if(response.code==0){
						 thisIns.preview=response.data;
					}else{
						thisIns.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			submitsecend(){   //预览之后的提交
			    const thisIns = this;
				this.$api.scoresecend({id:thisIns.id,remarks:thisIns.remarks}).then(function (response) {
					thisIns.DialogVisible=false;
					console.log("提交结果：",response);
					if(response.code==0){
						 thisIns.$vs.notify({
						 	  title:"提示",
						 	  color:'success',
						 	  text:response.message,
						 	  position:'top-center'
						 });
						 thisIns.getlist();
					}else{
						thisIns.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				  }) 
			},
			getlist(){    //获取列表
					 const thisIns = this;
					 var start=thisIns.yearmonth[0]||'';
					 var end=thisIns.yearmonth[1]||'';
					 this.$api.Scorelist({pageNum:thisIns.itemsPerPage,pageSize:10,status:2,startTime:start,endTime:end,name:thisIns.name}).then(function (response) {
					 	console.log("列表数据：",response);
					 	if(response.code==0){
					 		 thisIns.culturelist=response.data.data;
					 		 thisIns.total=response.data.pages;
					 	}else{
					 		thisIns.$vs.notify({
					 			  title:"提示",
					 			  color:'warning',
					 			  text:response.message,
					 			  position:'top-center'
					 		});
					 	}
					   }) 
			},
			details(item){  //详情
				localStorage.setItem("userdetails",JSON.stringify(item));
				this.$router.push({path:'/admin/scoreddetails',query:{id:item.id}})
			},
			todetails(item){  //评分之后的详情
				localStorage.setItem("userdetails",JSON.stringify(item));
				this.$router.push({path:'/admin/notesdetails',query:{id:item.id}})
			},
			exportexcel(id){
				let token = localStorage.getItem('token');
				window.open(`${this.$baseURL}/staffAssess/conserve?id=${id}&authorization=${token}`);
			},
			
		},
	}
</script>
<style type="text/css">
	
</style>
